import "./AboutContentStyles.css";
import React from 'react';
import { FaPython, FaJsSquare, FaPhp, FaHtml5, FaCss3Alt, FaRobot, FaReact, FaDatabase } from 'react-icons/fa';
import { SiEthereum, SiSolidity } from 'react-icons/si';
import digitalMarketingImage from '../assets/Digital marketing.jpg'; 
import PhpImage from '../assets/Php Image.jpg'; 
import wordpress from '../assets/Wordpress image.jpg'; 
import Msc from '../assets/MSC1.jpg';
import useIntersectionObserver from '../hooks/useIntersectionObserver';

const experienceData = [
  {
    role: 'Technical Solutions Specialist (Internship)',
    company: 'SuperDesk',
    location: 'Ahmedabad, India',
    period: 'Jun 2021 — Oct 2022',
    highlights: [
      'Developed scalable data ingestion pipelines to process and transform large datasets.',
      'Automated catalog management using Python, reducing manual workload by 40%.',
      'Built APIs and database solutions to streamline data integration and reporting.',
      'Worked with monitoring tools for system performance.',
    ],
  },
];

const AboutContent = () => {
  const [ref1, isVisible1] = useIntersectionObserver({ threshold: 0.2 });
  const [ref2, isVisible2] = useIntersectionObserver({ threshold: 0.2 });
  const [ref3, isVisible3] = useIntersectionObserver({ threshold: 0.2 });
  const [ref4, isVisible4] = useIntersectionObserver({ threshold: 0.15 });

  return (
    <div className="about">
      <div ref={ref1} className={`left ${isVisible1 ? 'visible' : 'hidden'}`}>
        <h1>Who Am I?</h1>
        <div className="bio-text">
          <p>I am a Multidisciplinary Technologist with expertise in frontend development (HTML, CSS, JavaScript, React), backend development (Python, Flask), database management (SQL), blockchain development (Solidity), Large Language Models (LLMs), and advanced technologies including Machine Learning and Artificial Intelligence.</p>
        </div>
        <div className="btn-container">
          <a href="#contact">
            <button className="btn">Contact</button>
          </a>
          <a href="/cv.pdf" download>
            <button className="btn">Download CV</button>
          </a>
        </div>
      </div>

      <div ref={ref2} className={`right ${isVisible2 ? 'visible' : 'hidden'}`}>
        <h1>Skills</h1>
        <div className="skills">
          <div className="skill">
            <FaPython color="#3776AB" />
            <p>Python</p>
          </div>
          <div className="skill">
            <FaJsSquare color="#F7DF1E" />
            <p>JavaScript</p>
          </div>
          <div className="skill">
            <FaPhp color="#777BB4" />
            <p>PHP</p>
          </div>
          <div className="skill">
            <FaHtml5 color="#E34F26" />
            <p>HTML</p>
          </div>
          <div className="skill">
            <FaCss3Alt color="#1572B6" />
            <p>CSS</p>
          </div>
          <div className="skill">
            <FaDatabase size={50} color="#4479A1" />
            <p>MySQL</p>
          </div>
          <div className="skill">
            <FaReact color="#61DBFB" />
            <p>React</p>
          </div>
          <div className="skill">
            <SiEthereum color="#627EEA" />
            <p>Blockchain</p>
          </div>
          <div className="skill">
            <FaRobot color="#FFD700" />
            <p>Machine Learning</p>
          </div>
          <div className="skill">
            <SiSolidity color="#363636" />
            <p>Solidity</p>
          </div>
        </div>
      </div>

      <div ref={ref4} className={`experience ${isVisible4 ? 'visible' : 'hidden'}`}>
        <h1>Work Experience</h1>
        <div className="experience-list">
          {experienceData.map((item) => (
            <article key={`${item.company}-${item.period}`} className="experience-item">
              <div className="experience-header">
                <div>
                  <h2 className="experience-role">{item.role}</h2>
                  <p className="experience-company">
                    {item.company} · {item.location}
                  </p>
                </div>
                <span className="experience-period">{item.period}</span>
              </div>
              <ul className="experience-highlights">
                {item.highlights.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
              {item.project && (
                <p className="experience-project">{item.project}</p>
              )}
              {item.tools && (
                <div className="experience-tools">
                  {item.tools.map((tool) => (
                    <span key={tool} className="experience-tool">{tool}</span>
                  ))}
                </div>
              )}
            </article>
          ))}
        </div>
      </div>

      <div ref={ref3} className={`bottom ${isVisible3 ? 'visible' : 'hidden'}`}>
        <div className="heading"><h1>Certificates</h1></div>
        <div className="certificate">
          <img className="jpeg" src={digitalMarketingImage} alt="Digital Marketing Certificate" />
        </div>
        <div className="certificate">
          <img className="jpeg" src={PhpImage} alt="PHP" />
        </div>
        <div className="certificate">
          <img className="jpeg" src={wordpress} alt="WordPress" />
        </div>
        <div className="certificate">
          <img className="jpeg" src={Msc} alt="MSC1" />
        </div>
      </div>
    </div>
  );
};

export default AboutContent;


